import { useMemo } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import {
  RaglCashBlotterTable,
  type RaglCashBlotterTableViewContext,
} from '../../../../../../../../../features/clearing-ledger/delta/ragl-cash-blotter-table';
import { getPageHead } from '../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/balance/_balance/$accountCode')({
  loader: ({ params }) =>
    ({
      breadcrumb: buildBreadcrumb({
        id: `clearing-balances-account-code-${params.accountCode}`,
        label: params.accountCode,
        to: `/clearing/operations/balance/${params.accountCode}`,
      }),
    }) satisfies AggregateBreadcrumb,
  head: ({ params }) => getPageHead(`${params.accountCode} Balance`),
  component: ClearingCashDeltasByAccountCodeList,
});

function ClearingCashDeltasByAccountCodeList() {
  const { accountCode } = Route.useParams();
  const viewContext = useMemo(
    () =>
      ({
        kind: 'accountCode',
        accountCode,
      }) as const satisfies RaglCashBlotterTableViewContext,
    [accountCode],
  );

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <RaglCashBlotterTable renderWhenEmpty="No Deltas" viewContext={viewContext} />
      </PageLayout.Section>
    </PageLayout>
  );
}
